import { render, staticRenderFns } from "./ExhibitionService.vue?vue&type=template&id=1a706c74&"
import script from "./ExhibitionService.vue?vue&type=script&lang=js&"
export * from "./ExhibitionService.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionService.vue?vue&type=style&index=0&id=1a706c74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports